'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _IconButtonStyle = require('./IconButton.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconButton = function IconButton(_ref) {
  var iconClassName = _ref.iconClassName,
      iconStyle = _ref.iconStyle,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['iconClassName', 'iconStyle']);
  return _react2.default.createElement(
    'button',
    rest,
    _react2.default.createElement('i', { className: iconClassName })
  );
};

exports.IconButton = IconButton;
IconButton.propTypes = {
  /**
   * String className for glyph icon
   */
  iconClassName: _propTypes2.default.string.isRequired,
  /**
   * Styles object for backwards compatibility. Use css prop instead.
   */
  iconStyle: _propTypes2.default.object,

  /**
   * Custom stlye object for icon
   */
  // iconStyle: PropTypes.string,
  /**
   * Action to perform on button click.
   */
  onClick: _propTypes2.default.func,
  /**
   * This property is required to apply glamorous styles to the component.
   * It is not necessary to add a className, but it will be merged with the
   * glamorous className if you do.
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Whether the button is disabled
   */
  disabled: _propTypes2.default.bool
};

IconButton.defaultProps = {
  disabled: false
};

exports.default = (0, _glamorous2.default)(IconButton)(_IconButtonStyle.defaultStyle, _IconButtonStyle.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/IconButton/IconButton.js
// module id = 109
// module chunks = 0